import apiUrl from '../../../../constants';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import ClientService from '../../../../modules/clientmanagement/services/clientmanagement.service';
import SimpleLineIcons from 'vue-simple-line'

export default {
  name: 'clientdashboard',
  components: {
    VueElementLoading,
    SimpleLineIcons,
  },
  props: [],
  data: function() {
    return {
      masterData : {},
      totalClient : 0,
      totaActiveClient : 0,
      totalPendingApprovalClient : 0,
      isLoading:false,
      dashBoardArr:[],
       max: 1000
    }
  },
  computed: {
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.useremail = userdetail.email;
    this.getCount();
  },
  methods: {
    async getCount(){
			try {
				this.isLoading = true;
				let inputPayload = {};
				let result = await ClientService.getClientCountForDashboard(inputPayload);
				if (result.data.code == 200) {
          this.dashBoardArr.push(result.data.data[0]);
          this.isLoading = false;
					this.totalClient = result.data.data[0].clientCount.onboardClientCount;
					this.totaActiveClient = result.data.data[0].clientCount.activeClientCount;
					this.totalPendingApprovalClient = result.data.data[0].pendingclientcont;
				}else {
					this.$alert("Unable to fetch Client data.","Client Data","error");
				}
			} catch(err){
				console.log(err);
				this.isLoading = false;
			}
		},
  }
}



// WEBPACK FOOTER //
// ./src/views/components/cargoclient/clientdashboard/clientdashboard.component.js